import Breadcrumbs from "../../../components/breadcrumbs";
import CharityCreateForm from "./ui/charity-create-form";

export default function CharityCreatePage(){
     return (
            <main className="max-w-3xl ">
              <Breadcrumbs
                breadcrumbs={[
                  { label: "Charities", href: "/admin/charities" },
                  {
                    label: "create",
                    href: `/admin/charities/Create`,
                    active: true,
                  },
                ]}
              />
              
                <CharityCreateForm/>
              
            </main>
          );
        }
